import { createFileRoute } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

export const Route = createFileRoute("/$lang/support")({
  head: ({ params }) => ({
    meta: [
      { title: "Support the project — MadCaptains" },
      { name: "description", content: "Donations keep the archive online and ad-free." },
      { property: "og:url", content: `/${params.lang}/support` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/support` }],
  }),
  component: SupportPage,
});

function SupportPage() {
  const { t } = useI18n();
  return (
    <PageShell eyebrow="Lighthouse Keepers" title={t.page_support_h1} lead={t.page_support_lead}>
      <p
        className="rounded-sm border-l-2 p-4 text-sm"
        style={{ borderColor: "var(--amber)", background: "color-mix(in oklab, var(--amber) 6%, transparent)" }}
      >
        {t.page_support_keepers}
      </p>
      <a
        href="https://ko-fi.com/madcaptains"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-flex items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-medium transition-opacity hover:opacity-90"
        style={{ background: "var(--amber)", color: "var(--ink)" }}
      >
        {t.page_support_cta}
      </a>
    </PageShell>
  );
}